import styled from 'styled-components';

const Column = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'half',
})`
  flex: ${({ half }) => (half ? 0.5 : 1)};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    flex: 1;
    width: 100%;
  }
`;

export default Column;
